// ============================================
// JOB UNITS - not every job is measured in tonnes.
// ============================================
// minerals / agri are TONNAGE jobs (MT). Container jobs are counted in boxes.
// An ABNORMAL load has NO tonnage at all - it is a movement, not a mineral - and a
// general services job may have neither. So showing "0 of 0 MT" on those is simply
// wrong. Every screen must ask this helper instead of reading total_quantity_mt directly.
//
//   units.kind === 'mt'        -> tonnes (use total/done + hasProgress)
//   units.kind === 'container' -> counted boxes (units.short, e.g. "3 x 6m")
//   units.kind === 'none'      -> abnormal / general: no tonnage at all
// ============================================

export const jobUnits = (job) => {
  const raw = (job && (job.quote_type || job.commodity_type)) || '';
  const t = String(raw).toLowerCase();

  if (t === 'container' || t === 'containers') {
    const n = Number(job && job.container_count) || 0;
    const size = (job && job.container_size) || '';
    return {
      kind: 'container',
      short: n ? `${n}${size ? ` × ${size}` : ''} container${n === 1 ? '' : 's'}` : 'Containers',
      total: n,
      done: 0,
      hasProgress: false
    };
  }

  if (t === 'minerals' || t === 'mining' || t === 'agri' || t === 'agricultural') {
    const total = Number(job && job.total_quantity_mt) || 0;
    const done = Number(job && job.delivered_quantity_mt) || 0;
    return { kind: 'mt', short: `${total} MT`, total, done, hasProgress: total > 0 };
  }

  // abnormal | general | anything unrecognised -> deliberately NO tonnage.
  return { kind: 'none', short: '', total: 0, done: 0, hasProgress: false };
};

// A rate only reads "/MT" on a tonnage job.
export const rateSuffix = (units) => (units && units.kind === 'mt' ? '/MT' : '');
